/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountMetricsDestination } from '../models/AccountMetricsDestination';

export class RestoreAccountMetricsConfig {
  /**
  * Eon-assigned restore account ID.
  */
  'restoreAccountId': string;
  /**
  * Indicates whether job metrics are enabled for the restore account. If `true`, job metrics are collected and can be queried. 
  */
  'enabled': boolean;
  'destination': AccountMetricsDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "AccountMetricsDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAccountMetricsConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

